import configModule from '../config/config-module';
import dataModule from '../data/data-module';
import formsModule from '../forms/forms-module';

import AuthService from './auth-service';
import authData from './auth-data';
import authMiddleware from './auth-middleware';


export default angular.module('auth', [configModule, dataModule, formsModule])
    .service('authService', AuthService)
    .factory('authData', authData)
    .run(authMiddleware)
    .name;



// WEBPACK FOOTER //
// ./auth/auth-module.js